/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * The current state of an agent phone number
 */
export enum AgentPhoneStatus {
  ACTIVE = 'ACTIVE',
  DRAINING = 'DRAINING',
  INACTIVE = 'INACTIVE',
}

export enum AnalyticsSplitBy {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
}

export enum AuditTrailOrigin {
  API = 'API',
  LEADLIST = 'LEADLIST',
}

export enum CallCenterHolidayInput {
  BLACK_FRIDAY = 'BLACK_FRIDAY',
  CHRISTMAS_DAY = 'CHRISTMAS_DAY',
  CHRISTMAS_DAY_OBSERVED = 'CHRISTMAS_DAY_OBSERVED',
  CHRISTMAS_EVE = 'CHRISTMAS_EVE',
  CHRISTMAS_EVE_OBSERVED = 'CHRISTMAS_EVE_OBSERVED',
  COLUMBUS_DAY = 'COLUMBUS_DAY',
  EASTER = 'EASTER',
  INDEPENDENCE_DAY = 'INDEPENDENCE_DAY',
  INDEPENDENCE_DAY_OBSERVED = 'INDEPENDENCE_DAY_OBSERVED',
  JUNETEENTH = 'JUNETEENTH',
  JUNETEENTH_OBSERVED = 'JUNETEENTH_OBSERVED',
  LABOR_DAY = 'LABOR_DAY',
  MARTIN_LUTHER_KING_JR_DAY = 'MARTIN_LUTHER_KING_JR_DAY',
  MEMORIAL_DAY = 'MEMORIAL_DAY',
  NEW_YEARS = 'NEW_YEARS',
  NEW_YEARS_DAY = 'NEW_YEARS_DAY',
  NEW_YEARS_DAY_OBSERVED = 'NEW_YEARS_DAY_OBSERVED',
  NEW_YEARS_EVE = 'NEW_YEARS_EVE',
  NEW_YEARS_EVE_OBSERVED = 'NEW_YEARS_EVE_OBSERVED',
  NEW_YEARS_OBSERVED = 'NEW_YEARS_OBSERVED',
  PRESIDENTS_DAY = 'PRESIDENTS_DAY',
  THANKSGIVING = 'THANKSGIVING',
  VETERANS_DAY = 'VETERANS_DAY',
  VETERANS_DAY_OBSERVED = 'VETERANS_DAY_OBSERVED',
}

/**
 * A call centers recognized holidays
 */
export enum CallCenterHolidays {
  BLACK_FRIDAY = 'BLACK_FRIDAY',
  CHRISTMAS_DAY = 'CHRISTMAS_DAY',
  CHRISTMAS_DAY_OBSERVED = 'CHRISTMAS_DAY_OBSERVED',
  CHRISTMAS_EVE = 'CHRISTMAS_EVE',
  CHRISTMAS_EVE_OBSERVED = 'CHRISTMAS_EVE_OBSERVED',
  COLUMBUS_DAY = 'COLUMBUS_DAY',
  EASTER = 'EASTER',
  INDEPENDENCE_DAY = 'INDEPENDENCE_DAY',
  INDEPENDENCE_DAY_OBSERVED = 'INDEPENDENCE_DAY_OBSERVED',
  JUNETEENTH = 'JUNETEENTH',
  JUNETEENTH_OBSERVED = 'JUNETEENTH_OBSERVED',
  LABOR_DAY = 'LABOR_DAY',
  MARTIN_LUTHER_KING_JR_DAY = 'MARTIN_LUTHER_KING_JR_DAY',
  MEMORIAL_DAY = 'MEMORIAL_DAY',
  NEW_YEARS = 'NEW_YEARS',
  NEW_YEARS_DAY = 'NEW_YEARS_DAY',
  NEW_YEARS_DAY_OBSERVED = 'NEW_YEARS_DAY_OBSERVED',
  NEW_YEARS_EVE = 'NEW_YEARS_EVE',
  NEW_YEARS_EVE_OBSERVED = 'NEW_YEARS_EVE_OBSERVED',
  NEW_YEARS_OBSERVED = 'NEW_YEARS_OBSERVED',
  PRESIDENTS_DAY = 'PRESIDENTS_DAY',
  THANKSGIVING = 'THANKSGIVING',
  VETERANS_DAY = 'VETERANS_DAY',
  VETERANS_DAY_OBSERVED = 'VETERANS_DAY_OBSERVED',
}

/**
 * The current state of a campaign
 */
export enum CampaignStatus {
  DRAINING = 'DRAINING',
  LIVE = 'LIVE',
  STOPPED = 'STOPPED',
}

export enum DeleteRecordingsLeadType {
  ALL = 'ALL',
  LEADS_ONLY = 'LEADS_ONLY',
  NON_LEADS_ONLY = 'NON_LEADS_ONLY',
}

export enum DeprovisionListMode {
  BY_COMPANY = 'BY_COMPANY',
  TOP_TEN = 'TOP_TEN',
}

export enum DeprovisionPhoneStatus {
  ERROR = 'ERROR',
  NOT_SOLD = 'NOT_SOLD',
  PENDING = 'PENDING',
  SOLD = 'SOLD',
}

export enum DeprovisionTopTenOrder {
  MOST_PHONES = 'MOST_PHONES',
  OLDEST = 'OLDEST',
}

/**
 * The direction of the message (inbound or outbound)
 */
export enum Direction {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

export enum ExperimentMetricName {
  callTransferRate = 'callTransferRate',
  carrierDncRate = 'carrierDncRate',
  clickThroughRate = 'clickThroughRate',
  dncRate = 'dncRate',
  engagementRate = 'engagementRate',
  smsDeliverability = 'smsDeliverability',
  smsSent = 'smsSent',
}

/**
 * The current status of a scheduler flow experiment
 */
export enum ExperimentStatus {
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED',
  SCHEDULED = 'SCHEDULED',
}

/**
 * Allowed field keys for filtering on leads_v2 columns: source, region
 */
export enum LeadFieldKey {
  REGION = 'REGION',
  SOURCE = 'SOURCE',
}

export enum LeadLinkClicksGroup {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
}

export enum LeadStatus {
  COMPLETE = 'COMPLETE',
  DEAD = 'DEAD',
  DNC = 'DNC',
  END_CONTACT = 'END_CONTACT',
  FLOW = 'FLOW',
  TRANSFER = 'TRANSFER',
}

export enum ListType {
  CLOSE = 'CLOSE',
  DNC = 'DNC',
  ENDCONTACT = 'ENDCONTACT',
  PROSPECTIVE = 'PROSPECTIVE',
}

export enum OutreachKind {
  FLOW = 'FLOW',
  REM = 'REM',
  REPLY = 'REPLY',
  SCHEDULE = 'SCHEDULE',
}

/**
 * Outcome of reconciling a requested field against the domain read-back.
 */
export enum ShortioFieldStatus {
  APPLIED = 'APPLIED',
  NEEDS_MANUAL = 'NEEDS_MANUAL',
  UPDATE_FAILED = 'UPDATE_FAILED',
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum SplitBy {
  Day = 'Day',
  Hour = 'Hour',
  Month = 'Month',
  Week = 'Week',
}

export enum Timezone {
  ANCHORAGE = 'ANCHORAGE',
  CHICAGO = 'CHICAGO',
  DENVER = 'DENVER',
  HAWAII = 'HAWAII',
  LOS_ANGELES = 'LOS_ANGELES',
  NEW_YORK = 'NEW_YORK',
  PHOENIX = 'PHOENIX',
  PUERTO_RICO = 'PUERTO_RICO',
}

export enum VariantSlot {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}

/**
 * The UI surface a chat message is authored from (admin vs client).
 */
export enum ViewerRole {
  admin = 'admin',
  client = 'client',
}

export enum WebhookAuthType {
  BASIC = 'BASIC',
  BEARER = 'BEARER',
  NONE = 'NONE',
}

export enum WebhookEvents {
  DNC_CREATED = 'DNC_CREATED',
  WEBCHAT_LEAD_CREATED = 'WEBCHAT_LEAD_CREATED',
}

export enum WebhookV2Events {
  CAMPAIGN_LEAD_CREATED = 'CAMPAIGN_LEAD_CREATED',
  DNC_CREATED = 'DNC_CREATED',
  LEAD_CALL_ENDED = 'LEAD_CALL_ENDED',
  LEAD_CALL_INITIATED = 'LEAD_CALL_INITIATED',
  LEAD_CALL_KEY_PRESSED = 'LEAD_CALL_KEY_PRESSED',
  LEAD_CALL_RECEIVED = 'LEAD_CALL_RECEIVED',
  LEAD_CALL_SCHEDULED = 'LEAD_CALL_SCHEDULED',
  LEAD_CALL_TRANSFERRED = 'LEAD_CALL_TRANSFERRED',
  LEAD_CARRIER_HELP_RECEIVED = 'LEAD_CARRIER_HELP_RECEIVED',
  LEAD_CARRIER_OPTIN_RECEIVED = 'LEAD_CARRIER_OPTIN_RECEIVED',
  LEAD_CARRIER_OPTOUT_RECEIVED = 'LEAD_CARRIER_OPTOUT_RECEIVED',
  LEAD_CONVERSATION_STARTED = 'LEAD_CONVERSATION_STARTED',
  LEAD_LANDLINE_DETECTED = 'LEAD_LANDLINE_DETECTED',
  LEAD_LINK_CLICKED = 'LEAD_LINK_CLICKED',
  LEAD_LINK_DELIVERED = 'LEAD_LINK_DELIVERED',
  LEAD_LINK_SENT = 'LEAD_LINK_SENT',
  LEAD_MESSAGE_DELIVERED = 'LEAD_MESSAGE_DELIVERED',
  LEAD_MESSAGE_RECEIVED = 'LEAD_MESSAGE_RECEIVED',
  LEAD_MESSAGE_SENT = 'LEAD_MESSAGE_SENT',
}

export interface AddCampaignToAgentConfigInput {
  companyId: string;
  agentConfigId: string;
  outreachTemplateId: string;
}

export interface AddReplacementToTemplatesInput {
  companyId: string;
  agentConfigId: string;
  key: string;
  value: string;
  name?: string | null;
}

export interface AddUserCompanyInput {
  companyId: string;
  userId: string;
}

export interface AnalyticsMetricsParams {
  companyId?: string | null;
  startDate: string;
  endDate: string;
  splitBy: AnalyticsSplitBy;
}

export interface AttributeMappingInput {
  email: string;
  username?: string | null;
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface AuditTrailDetailsInput {
  companyId?: string | null;
  phone: string;
  campaignShortId?: string | null;
  submitted?: string | null;
}

export interface AuditTrailFilterInput {
  companyId?: string | null;
  search?: string | null;
  campaignShortId?: string | null;
  status?: string[] | null;
  rejectedOnly?: boolean | null;
}

export interface CallCenterHolidaysInput {
  callCenterId: string;
  holidays: CallCenterHolidayInput[];
}

export interface CallCenterHoursDaysInput {
  mon?: CallCenterHoursRangeInput | null;
  tue?: CallCenterHoursRangeInput | null;
  wed?: CallCenterHoursRangeInput | null;
  thu?: CallCenterHoursRangeInput | null;
  fri?: CallCenterHoursRangeInput | null;
  sat?: CallCenterHoursRangeInput | null;
  sun?: CallCenterHoursRangeInput | null;
}

export interface CallCenterHoursRangeInput {
  from: string;
  to: string;
}

export interface CallCenterHoursUpdateInput {
  callCenterId: string;
  hours: CallCenterHoursDaysInput;
  isAlwaysOpen: boolean;
  timezone: Timezone;
}

export interface CampaignDidUpdateInput {
  campaignId: string;
  didInbound: string;
  didOutbound?: string | null;
  didScheduledOutbound?: string | null;
  callCenterId?: string | null;
}

export interface CampaignPostingConfigUpdateInput {
  campaignId: string;
  delay?: number | null;
  sameDay?: boolean | null;
}

export interface CampaignPostingUpdateInput {
  campaignId: string;
  limits: CampaignPostingUpdateLimits;
}

export interface CampaignPostingUpdateLimits {
  mon: number;
  tue: number;
  wed: number;
  thu: number;
  fri: number;
  sat: number;
  sun: number;
}

export interface CampaignRequiredMetadataUpdateInput {
  campaignId: string;
  requiredMetadata?: string[] | null;
}

export interface CampaignStandardFlowIdInput {
  campaignId: string;
  schedulerFlowId: string;
}

export interface CampaignStatusUpdateInput {
  campaignId: string;
  status: CampaignStatus;
}

export interface CategoryInput {
  label: string;
  prompt?: string | null;
  subagents: SubagentInput[];
}

export interface ChatEvent {
  type: string;
  message_id?: string | null;
  call_id?: string | null;
  no_response?: boolean | null;
  event_time: string;
  direction: string;
  message: string;
  system: string;
  replying_to_message_id?: string | null;
  vendor_status?: string | null;
  confidence?: number | null;
  intent?: string | null;
}

export interface CompanyCampaignParams {
  companyId?: string | null;
  campaignId?: string | null;
  startDate: string;
  endDate: string;
}

export interface CopySchedulerFlowInput {
  id: string;
  name: string;
}

export interface CreateAgentConfigInput {
  companyId: string;
  name: string;
  description: string;
  prompt: string;
  inboundGuardrails: CreateGuardrailItemInput[];
  outboundGuardrails: CreateGuardrailItemInput[];
  knowledgeBases: string[];
  llmModel?: string | null;
  backupLlmModel?: string | null;
  skipCallScheduling?: boolean | null;
}

export interface CreateAppClientInput {
  companyId: string;
}

export interface CreateBaseAgentConfigInput {
  companyId: string;
  name: string;
  description: string;
  prompt: string;
  inboundGuardrails: CreateGuardrailItemInput[];
  outboundGuardrails: CreateGuardrailItemInput[];
  knowledgeBases: string[];
  llmModel?: string | null;
  backupLlmModel?: string | null;
  skipCallScheduling?: boolean | null;
  agentId: string;
}

export interface CreateCallCenterInput {
  hours: CallCenterHoursDaysInput;
  isAlwaysOpen: boolean;
  timezone: Timezone;
  holidays: CallCenterHolidayInput[];
}

export interface CreateCampaignInput {
  companyId: string;
  campaignName: string;
  agentName: string;
  brandName: string;
  callCenterId: string;
  didInbound: string;
  didOutbound: string;
  isRealtime: boolean;
  salesforceOpportunityId?: string | null;
  crmRecordId?: string | null;
  createOutreachTemplate?: CreateSchedulerFlowInput | null;
  duplicateOutreachTemplate?: CopySchedulerFlowInput | null;
  useExistingOutreachTemplateId?: string | null;
  minTransferDuration: number;
}

export interface CreateCompanyInput {
  name: string;
  leadListUploadEmail?: string | null;
  callCenter: CreateCallCenterInput;
}

export interface CreateDncInput {
  campaignId: string;
  phone: string;
}

export interface CreateGuardrailInput {
  companyId: string;
  name: string;
  description: string;
  prompt: string;
  examples: string[];
  defaultRespondWith: string;
  isActive: boolean;
}

export interface CreateGuardrailItemInput {
  id: string;
  isActive?: boolean | null;
  respondWith?: string | null;
}

export interface CreateIvrInput {
  text: string;
}

export interface CreateLeadListInput {
  shortId?: string | null;
  columnMapping: any;
  estimatedTotalRows?: number | null;
  fileName: string;
  listType: ListType;
  userName: string;
  companyId?: number | null;
}

export interface CreateLlmInput {
  companyId: string;
  outreachTemplateId: string;
  prompt: string;
  inboundGuardrails: CreateGuardrailItemInput[];
  outboundGuardrails: CreateGuardrailItemInput[];
  knowledgeBases: string[];
}

export interface CreateNewConfigOptionsInput {
  source: string;
  sourceId?: string | null;
  name: string;
  description: string;
}

export interface CreateOrUpdateOidcSsoInput {
  name: string;
  attributesRequestMethod: string;
  clientId: string;
  clientSecret: string;
  issuer: string;
  authorizeScopes: string;
  attributes: AttributeMappingInput;
}

export interface CreateOrUpdateSamlSsoInput {
  name: string;
  metadataXml?: string | null;
  metadataUrl?: string | null;
  attributes: AttributeMappingInput;
}

export interface CreateSchedulerFlowExperimentInput {
  schedulerFlowAId: string;
  schedulerFlowAVolume: number;
  schedulerFlowBId?: string | null;
  schedulerFlowBVolume?: number | null;
  schedulerFlowCId?: string | null;
  schedulerFlowCVolume?: number | null;
  schedulerFlowDId?: string | null;
  schedulerFlowDVolume?: number | null;
  start?: any | null;
  end?: any | null;
  campaignId: string;
}

export interface CreateSchedulerFlowInput {
  companyId: string;
  name: string;
  config: string;
  afterHoursOutreach: string;
  nlpAgentId: string;
}

export interface CreateShortioDomainInput {
  hostname: string;
  linkType?: string | null;
  hideReferer?: boolean | null;
  httpsLevel?: string | null;
  robots?: string | null;
  redirect404?: string | null;
  segmentKey?: string | null;
  cloaking?: boolean | null;
  hideVisitorIp?: boolean | null;
  httpsLinks?: boolean | null;
  webhookURL?: string | null;
  integrationGA?: string | null;
  integrationFB?: string | null;
  integrationAdroll?: string | null;
  integrationGTM?: string | null;
  enableAI?: boolean | null;
  caseSensitive?: boolean | null;
  desiredIpExclusions?: string[] | null;
}

export interface CreateTcrCampaignInput {
  brandId: string;
  upstreamCnpId: string;
  embeddedLink: boolean;
  embeddedPhone: boolean;
  affiliateMarketing: boolean;
  numberPool: boolean;
  ageGated: boolean;
  directLending: boolean;
  subscriberOptin: boolean;
  subscriberOptout: boolean;
  subscriberHelp: boolean;
  usecase: string;
  subUsecases?: string[] | null;
  mnos: number[];
}

export interface CreateTestLeadInput {
  companyId: string;
  campaignId: string;
  phone: string;
  firstName: string;
  source?: string | null;
}

export interface CreateUserPoolDomainInput {
  companyId: string;
  cognitoDomainStart: string;
}

export interface CreateUserPoolInput {
  companyId: string;
  domain: string;
}

export interface CreateWebhookCustomPayloadInput {
  eventType: WebhookV2Events;
  requestTemplate?: string | null;
  contentType?: string | null;
  authType: WebhookAuthType;
  customHeaders?: any | null;
  authConfig?: any | null;
}

export interface CreateWebhookInput {
  campaignId: string;
  eventType: WebhookEvents;
  webhookUrl: string;
  clientSecret: string;
}

export interface CreateWebhookV2Input {
  campaignId?: string | null;
  events: WebhookV2Events[];
  webhookUrl: string;
  clientSecret: string;
}

export interface CustomizeExamplesInput {
  tone: string;
  additionalInformation: string;
  examples: ExampleInput[];
}

export interface DateFilter {
  in?: any[] | null;
  equals?: any | null;
  not?: any | null;
  notIn?: any[] | null;
  lt?: any | null;
  lte?: any | null;
  gt?: any | null;
  gte?: any | null;
  startsWith?: any | null;
  endsWith?: any | null;
}

export interface DeleteIdentityProviderInput {
  name: string;
}

export interface DeleteRecordingsInput {
  onlyDeleteIfInS3: boolean;
  minDurationInSeconds: number;
  amountToDelete: number;
  createdFrom?: string | null;
  createdTo?: string | null;
  leadType: DeleteRecordingsLeadType;
}

export interface DeleteUserInput {
  username: string;
}

export interface DeleteWebhookCustomPayloadInput {
  webhookCustomPayloadId: string;
}

export interface ExampleInput {
  title: string;
  context: string;
  message: string;
  output: string;
}

export interface FetchFreeSlotsInput {
  companyId?: string | null;
  startDate?: string | null;
  endDate?: string | null;
}

export interface GenerateMessagesInput {
  campaignFocus: string;
  customCampaignFocus?: string | null;
  industry: string;
  leadStatus: string;
  campaignGoal: string;
  contactInfo?: string | null;
  contactReason?: string | null;
  goalCompletionMethod: string;
  repName?: string | null;
  callPurpose?: string | null;
  callLength?: string | null;
  linkDestination?: string | null;
  linkPurpose?: string | null;
  otherDescription?: string | null;
  additionalInformation?: string | null;
  tone?: string | null;
  numMessages: number;
  systemPromptOverride?: string | null;
}

export interface GetCompanyLeadListStatsInput {
  companyId?: string | null;
  campaignId?: string | null;
}

export interface GetInboundSmsInput {
  day: string;
  companyId: string;
  onlyUnread: boolean;
}

export interface GoogleCalendarDayHoursInput {
  day: string;
  start: string;
  end: string;
}

export interface GoogleCalendarRepInput {
  id: string;
  name: string;
  calendarId: string;
}

export interface GuardrailItemInput {
  id: string;
  isActive: boolean;
  respondWith?: string | null;
}

export interface IntFilter {
  equals?: number | null;
  in?: number[] | null;
  notIn?: number[] | null;
  lt?: number | null;
  lte?: number | null;
  gt?: number | null;
  gte?: number | null;
  not?: number | null;
}

export interface InviteUserInput {
  companyId: string;
  email: string;
  groups: string[];
}

export interface KnowledgeBaseItemInput {
  id: string;
  isActive: boolean;
}

export interface LeadAdvanceFlowInput {
  campaignId: string;
  leadId: string;
}

export interface LeadLinkClicksParams {
  group: LeadLinkClicksGroup;
  time: string;
  companyId?: string | null;
  campaignId?: string | null;
}

export interface LeadListsFilter {
  created?: DateFilter | null;
  status?: IntFilter | null;
  sentToCampaign?: DateFilter | null;
  deleted?: DateFilter | null;
  listType?: ListType | null;
  companyId?: number | null;
}

export interface LeadListsRemoveUnpostedLeadsUpdateInput {
  leadListId: string;
}

export interface LeadResetInput {
  campaignId: string;
  leadId: string;
}

export interface LlmAgentFilter {
  text?: string | null;
  integration?: string | null;
  companyIds?: string[] | null;
}

export interface LlmConfigChangeHistoryInput {
  companyId: string;
  configId: string;
  operationType?: string | null;
  limit?: number | null;
  offset?: number | null;
}

export interface MarkLeadAsUnreadInput {
  phone: string;
  campaignId: string;
  modifiedBy?: string | null;
  readStatusId: string;
}

export interface MetadataFilterInput {
  key?: string | null;
  fieldKey?: LeadFieldKey | null;
  value?: string | null;
  and?: MetadataFilterInput[] | null;
  or?: MetadataFilterInput[] | null;
}

export interface MigrateToBridgeInput {
  companyId: string;
  legacyConfigId: string;
  agentConfigurationId?: string | null;
  createNew?: CreateNewConfigOptionsInput | null;
}

export interface OpenProposalInput {
  threadId?: string | null;
  schedulerFlowId?: string | null;
  actionId?: string | null;
  companyId: string;
  campaignId?: string | null;
  proposedMessage: string;
  proposedMediaUrl?: string | null;
  originalMessageSnapshot?: string | null;
  proposedSendWindow?: string | null;
  originalSendWindowSnapshot?: string | null;
  msgId?: string | null;
}

export interface OpenThreadInput {
  schedulerFlowId: string;
  actionId: string;
  companyId: string;
  campaignId?: string | null;
}

export interface Pagination {
  limit?: number | null;
  page?: number | null;
  search?: string | null;
  sortDirection?: SortDirection | null;
  sortField?: string | null;
}

export interface ProvisionVendorInput {
  campaignId: string;
  ivrFolder: string;
  agentPhoneNumber: string;
  volume: number;
}

export interface RemoveCampaignFromAgentConfigInput {
  companyId: string;
  outreachTemplateId: string;
}

export interface ReportFilterInput {
  companyId?: string | null;
  campaignId?: string | null;
  startDate: any;
  endDate: any;
  metadataFilter?: MetadataFilterInput | null;
}

export interface RevertLlmConfigChangeInput {
  companyId: string;
  configId: string;
  operationId: string;
  operationType: string;
}

export interface SaveIvrsInput {
  folderName: string;
  inboundUrl: string;
  scheduledUrl: string;
  unscheduledUrl: string;
}

export interface SaveMessagesInput {
  companyId: string;
  messages: string[];
}

export interface SendChatMessageInput {
  text: string;
  context: ChatEvent[];
  campaignId: string;
  companyId: string;
  outreachTemplateId: string;
  agentId: string;
  phone: string;
  firstName: string;
  lastName: string;
  timeZone: string;
  customPrompt?: string | null;
}

export interface SendOutreachChatMessageInput {
  schedulerFlowId: string;
  campaignId: string;
  companyId: string;
  body: string;
  viewerRole: ViewerRole;
}

export interface SendSmsInput {
  campaignId: string;
  leadPhoneNumber: string;
  body: string;
  when?: any | null;
  interveneUntil?: any | null;
}

export interface SetUserGroupsInput {
  companyId: string;
  username: string;
  groups: string[];
}

export interface SplitParams {
  splitBy: SplitBy;
}

export interface StringFilter {
  in?: string[] | null;
  equals?: string | null;
  not?: string | null;
  notIn?: string[] | null;
  lt?: string | null;
  lte?: string | null;
  gt?: string | null;
  gte?: string | null;
  contains?: string | null;
  startsWith?: string | null;
  endsWith?: string | null;
}

export interface SubagentInput {
  label: string;
  prompt: string;
  campaignId?: string | null;
}

export interface SyncLeadWithHighLevelInput {
  campaignId: string;
  leadPhoneNumber: string;
}

export interface TestDncWebhookInput {
  webhookId: string;
  phoneNumber: string;
  externalLeadId?: string | null;
}

export interface TestWebhookV2Input {
  webhookId: string;
  campaignId?: string | null;
  event: WebhookV2Events;
  payload: string;
}

export interface UnrejectLeadInput {
  lineNumber: number;
  firstName: string;
}

export interface UpdateAgentConfigDetailsInput {
  companyId: string;
  agentConfigId: string;
  name?: string | null;
  description?: string | null;
}

export interface UpdateBaseAgentCategoriesInput {
  agentId: string;
  companyId: string;
  categories: CategoryInput[];
}

export interface UpdateCampaignIvrUrlsInput {
  inboundIvrAudioUrl?: string | null;
  scheduledIvrAudioUrl?: string | null;
  unscheduledIvrAudioUrl?: string | null;
}

export interface UpdateGoHighLevelTagConfig {
  campaignId: string;
  tag: string;
}

export interface UpdateGoogleCalendarConfig {
  campaignId: string;
  timezone: Timezone;
  reps: GoogleCalendarRepInput[];
  appointmentsPerSlot?: number | null;
  schedule?: GoogleCalendarDayHoursInput[] | null;
  slotMinutes?: number | null;
  arrivalWindowHours?: number | null;
  eventMemo?: string | null;
  daysAhead?: number | null;
  scheduleStartDate?: string | null;
  scheduleThroughDate?: string | null;
  assignToUserId?: string | null;
}

export interface UpdateGuardrailInput {
  companyId: string;
  name: string;
  description: string;
  prompt: string;
  examples: string[];
  defaultRespondWith: string;
  isActive: boolean;
  id: string;
}

export interface UpdateHubspotConfig {
  campaignId: string;
  postLeadStageId: string;
  postLeadStageName: string;
}

export interface UpdateInviteTemplateInput {
  companyId: string;
  emailSubject?: string | null;
  emailMessage?: string | null;
}

export interface UpdateLeadCommentInput {
  phone: string;
  campaignId: string;
  comment?: string | null;
  readStatusId?: string | null;
  modifiedBy?: string | null;
}

export interface UpdateLeadInterveneUntilInput {
  campaignId: string;
  leadPhoneNumber: string;
  interveneUntil?: any | null;
}

export interface UpdateLeadIntervenedInput {
  phone: string;
  campaignId: string;
  readStatusId?: string | null;
  isIntervened: boolean;
  modifiedBy?: string | null;
}

export interface UpdateLeadStatusInput {
  campaignId: string;
  leadPhoneNumber: string;
  newStatus: LeadStatus;
}

export interface UpdateLeadUndeliverableReasonInput {
  campaignId: string;
  leadPhoneNumber: string;
  undeliverableReason?: string | null;
}

export interface UpdateLlmGuardrailsInput {
  lmdId?: string | null;
  agentConfigId?: string | null;
  companyId: string;
  inboundGuardrails: GuardrailItemInput[];
  outboundGuardrails: GuardrailItemInput[];
}

export interface UpdateLlmKnowledgeBasesInput {
  llmId?: string | null;
  agentConfigId?: string | null;
  companyId: string;
  knowledgeBases: KnowledgeBaseItemInput[];
}

export interface UpdateLlmModelsInput {
  companyId: string;
  outreachTemplateId?: string | null;
  agentConfigId?: string | null;
  llmModel?: string | null;
  backupLlmModel?: string | null;
  skipCallScheduling?: boolean | null;
}

export interface UpdateLlmPromptInput {
  companyId: string;
  outreachTemplateId?: string | null;
  agentConfigId?: string | null;
  prompt: string;
}

export interface UpdateProposalInput {
  proposalId: string;
  proposedMessage: string;
  proposedMediaUrl?: string | null;
  proposedSendWindow?: string | null;
  originalMessageSnapshot?: string | null;
  originalSendWindowSnapshot?: string | null;
  msgId?: string | null;
}

export interface UpdateReadStatusInput {
  phone: string;
  campaignId: string;
  timestamp: any;
  modifiedBy?: string | null;
}

export interface UpdateSchedulerFlowConfigInput {
  id: string;
  config: string;
}

export interface UpdateSchedulerFlowDelayInboundSmsInput {
  id: string;
  delayInboundSmsHandlingSeconds?: number | null;
}

export interface UpdateSchedulerFlowDoubleOptInInput {
  id: string;
  doubleOptInRequired?: boolean | null;
  doubleOptInNlpAgentId?: string | null;
  doubleOptInSmsMessageFk?: string | null;
  doubleOptInSmsMessage?: string | null;
}

export interface UpdateSchedulerFlowExperimentInput {
  id: string;
  schedulerFlowAId: string;
  schedulerFlowAVolume: number;
  schedulerFlowBId?: string | null;
  schedulerFlowBVolume?: number | null;
  schedulerFlowCId?: string | null;
  schedulerFlowCVolume?: number | null;
  schedulerFlowDId?: string | null;
  schedulerFlowDVolume?: number | null;
  start?: any | null;
  end?: any | null;
}

export interface UpdateSmsGeneratorInput {
  id: string;
  smsGeneratorId?: string | null;
  name?: string | null;
  replacements: string[][];
}

export interface UpdateTcrCampaignInput {
  description: string;
  helpKeywords: string;
  optinKeywords: string;
  optoutKeywords: string;
  optoutMessage: string;
  helpMessage: string;
  messageFlow: string;
  sample1: string;
  sample2: string;
  sample3: string;
  sample4: string;
}

export interface UpdateWebhookCustomPayloadInput {
  webhookCustomPayloadId: string;
  requestTemplate?: string | null;
  contentType?: string | null;
  customHeaders?: any | null;
  authType?: WebhookAuthType | null;
  authConfig?: any | null;
  enabled?: boolean | null;
}

export interface UpdateWebhookInput {
  webhookUrl: string;
  clientSecret: string;
  webhookId: string;
}

export interface UpdateWebhookV2Input {
  webhookId: string;
  webhookUrl: string;
  clientSecret: string;
  events: WebhookV2Events[];
}

export interface UploadIvrFileInput {
  folderName: string;
  fileName: string;
  contentType: string;
  fileBase64: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
